import { Navigate } from "react-router-dom";

/**
 * "Univers créatif" — sous-onglet du portfolio (signature, mood tags, headline).
 *
 * Cette route préserve un point d'entrée propre depuis la sidebar (Profil → Univers)
 * et redirige vers la TalentPortfolioPage avec l'onglet `signature` ouvert.
 *
 * Le composant existant gère déjà l'onglet via `?tab=signature`.
 */
export default function TalentUniverse() {
  return <Navigate to="/talent/portfolio?tab=signature" replace />;
}
